import { render, staticRenderFns } from "./ModuleTemplateApplicationPage.vue?vue&type=template&id=567cdb74&"
import script from "./ModuleTemplateApplicationPage.vue?vue&type=script&lang=js&"
export * from "./ModuleTemplateApplicationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports